import { watch, ref, computed, onBeforeUnmount } from 'vue'

export const useSelectedRowNodes = ({ gridApi }) => {
  const selectedRowNodes = ref([])
  const totalSelectedRowNodes = computed(() => selectedRowNodes.value.length)
  const selectedRowNodeIds = computed(() => selectedRowNodes.value.map((node) => node.data.id))

  const onSelectionChanged = () => {
    const isServerSide = gridApi.value.getGridOption('rowModelType') === 'serverSide'

    const currentlySelectedNodes = []

    if (!isServerSide) {
      gridApi.value.forEachNode((node) => {
        if (node.isSelected()) {
          currentlySelectedNodes.push(node)
        }
      })
      selectedRowNodes.value = currentlySelectedNodes
      return
    }

    const pageSize = gridApi.value.paginationGetPageSize()
    const currentPage = gridApi.value.paginationGetCurrentPage()

    const validRange = {
      start: currentPage * pageSize,
      end: (currentPage + 1) * pageSize
    }

    gridApi.value.forEachNode((node) => {
      if (node.isSelected() && node.rowIndex >= validRange.start && node.rowIndex < validRange.end) {
        currentlySelectedNodes.push(node)
      }
    })
    selectedRowNodes.value = currentlySelectedNodes
  }

  watch(
    gridApi,
    () => {
      gridApi.value.addEventListener('selectionChanged', onSelectionChanged)
    },
    { once: true }
  )

  onBeforeUnmount(() => {
    gridApi.value.removeEventListener('selectionChanged', onSelectionChanged)
  })

  return {
    selectedRowNodes,
    selectedRowNodeIds,
    totalSelectedRowNodes
  }
}
